const powerUnits = ['kW', 'hp'];

const rangeUnits = ['km', 'mi'];

const fuelCapacityUnits = ['L', 'gal'];

const displacementUnits = ['L', 'cc'];

const powertrainOptionalValues = ['HEV', 'ICE', 'PHEV'];

const ASSET_CLASS = ['VAN', 'TRUCK', 'CAR', 'BUS', 'MOTORCYCLE'];

export {
  powerUnits,
  rangeUnits,
  fuelCapacityUnits,
  displacementUnits,
  powertrainOptionalValues,
  ASSET_CLASS,
};
